export default "__VITE_ASSET__e6439d34__"